<template>
    <div>

        <div class="flex w-full mt-4 mt-lg-0 justify-content-lg-between">
            <div class="flex flex-column mx-2" style="width: 95%;">
                <div class="rounded bg-white shadow-md">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Project Data Fields</span>
                    </div>

                    <div class="pt-2 pb-2 px-3">
                        <table v-if="labels.length > 0" style="width: 100%">
                            <draggable v-model="labels" @change="handleLabelOrderChange">
                                <transition-group>
                                    <div v-for="(label, index) in labels" :key="'unique-identifier-'+label.label_type+'-'+label.id"
                                         :class="team.has_reorder_and_hide_access ? 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover' : 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover drag-stop'"
                                         :id="label.id">

                                        <div class="col-md-9 p-0 m-0 pt-1">
                                            <div class="w-100">
                                                <div class="text-black font-weight-light" :title="label.current_label">
                                                    <img :src="baseUrl+'/images/drag-icon.png'" class="drag-icon-img float-left pt-1 mr-1" v-if="team.has_reorder_and_hide_access">
                                                    {{ label.current_label }} <span class="badge badge-primary">{{ label.actual_label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 p-0 m-0 text-right" v-if="team.has_reorder_and_hide_access">
                                            <i :class="'fa fa-eye mr-2 cursor-pointer eye-show-'+label.id" aria-hidden="true" v-if="label.label_view" @click="updateView(label, index, '0')"></i>
                                            <i :class="'fa fa-eye-slash mr-2 cursor-pointer eye-slash-'+label.id" style="color: #cc1f1a;" aria-hidden="true" v-if="!label.label_view" @click="updateView(label, index, '1')"></i>
                                            <button @click.prevent="openEditFieldModal(index, label, 'project-data-label')"
                                                    class="btn btn-default btn-sm material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                            </button>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                        </table>
                        <div v-if="labelsLoader" class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only text-teal">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rounded bg-white shadow-md mt-3">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Project Custom fields</span>
                    </div>

                    <div class="pt-2 pb-2 px-3">
                        <table v-if="customFieldsLables.length > 0" style="width: 100%">
                            <draggable v-model="customFieldsLables" @change="handleCustomFieldsOrderChange">
                                <transition-group>
                                    <div v-for="(customFields, index) in customFieldsLables" :key="'unique-identifier-'+customFields.label_type+'-'+customFields.id"
                                         :class="team.has_reorder_and_hide_access ? 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover' : 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover drag-stop'"
                                         :id="label.id">

                                        <div class="col-md-9 p-0 m-0 pt-1">
                                            <div class="w-100">
                                                <div class="text-black font-weight-light" :title="customFields.current_label">
                                                    <img :src="baseUrl+'/images/drag-icon.png'" class="drag-icon-img float-left pt-1 mr-1" v-if="team.has_reorder_and_hide_access">
                                                    {{ customFields.current_label }} <span class="badge badge-primary">{{ customFields.actual_label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 p-0 m-0 text-right" v-if="team.has_reorder_and_hide_access">
                                            <i :class="'fa fa-eye mr-2 cursor-pointer eye-show-'+customFields.id" aria-hidden="true" v-if="customFields.label_view" @click="updateCustomFieldView(customFields, index, '0')"></i>
                                            <i :class="'fa fa-eye-slash mr-2 cursor-pointer eye-slash-'+customFields.id" style="color: #cc1f1a;" aria-hidden="true" v-if="!customFields.label_view" @click="updateCustomFieldView(customFields, index, '1')"></i>
                                            <button @click.prevent="openEditFieldModal(index, customFields, 'custom-data-label')"
                                                    class="btn btn-default btn-sm material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                            </button>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                        </table>
                        <div v-if="customFieldsLabelsLoader" class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only text-teal">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-column mx-2" style="width: 95%;">
                <div class="rounded bg-white shadow-md">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Record Details Fields</span>
                    </div>

                    <div class="pt-2 pb-2 px-3">
                        <table v-if="recordDetailLabels.length > 0" style="width: 100%">
                            <draggable v-model="recordDetailLabels" @change="handleRecordDetailLabelOrderChange">
                                <transition-group>
                                    <div v-for="(label, index) in recordDetailLabels" :key="'unique-identifier-'+label.label_type+'-'+label.id"
                                         :class="team.has_reorder_and_hide_access ? 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover' : 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover drag-stop'"
                                         :id="label.id">

                                        <div class="col-md-9 p-0 m-0 pt-1">
                                            <div class="w-100">
                                                <div class="text-black font-weight-light" :title="label.current_label">
                                                    <img :src="baseUrl+'/images/drag-icon.png'" class="drag-icon-img float-left pt-1 mr-1" v-if="team.has_reorder_and_hide_access">
                                                    {{ label.current_label }} <span class="badge badge-primary">{{ label.actual_label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 p-0 m-0 text-right" v-if="team.has_reorder_and_hide_access">
                                            <i :class="'fa fa-eye mr-2 cursor-pointer eye-show-'+label.id" aria-hidden="true" v-if="label.label_view" @click="updateRecordDetailView(label, index, '0')"></i>
                                            <i :class="'fa fa-eye-slash mr-2 cursor-pointer eye-slash-'+label.id" style="color: #cc1f1a;" aria-hidden="true" v-if="!label.label_view" @click="updateRecordDetailView(label, index, '1')"></i>
                                            <button @click.prevent="openRecordDetailEditFieldModal(index, label, 'record-detail-label')"
                                                    class="btn btn-default btn-sm material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                            </button>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                        </table>
                        <div v-if="recordDetailLabelsLoader" class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only text-teal">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rounded bg-white shadow-md mt-3">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Record Details Custom fields</span>
                    </div>

                    <div class="pt-2 pb-2 px-3">
                        <table v-if="recordDetailCustomFieldsLabels.length > 0" style="width: 100%">
                            <draggable v-model="recordDetailCustomFieldsLabels" @change="handleRecordDetailCustomFieldsOrderChange">
                                <transition-group>
                                    <div v-for="(customFields, index) in recordDetailCustomFieldsLabels" :key="'unique-identifier-'+customFields.label_type+'-'+customFields.id"
                                         :class="team.has_reorder_and_hide_access ? 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover' : 'flex justify-between border-2 py-2 rounded tracking-wide cursor-pointer border-0 project-data-label-hover drag-stop'"
                                         :id="label.id">

                                        <div class="col-md-9 p-0 m-0 pt-1">
                                            <div class="w-100">
                                                <div class="text-black font-weight-light" :title="customFields.current_label">
                                                    <img :src="baseUrl+'/images/drag-icon.png'" class="drag-icon-img float-left pt-1 mr-1" v-if="team.has_reorder_and_hide_access">
                                                    {{ customFields.current_label }} <span class="badge badge-primary">{{ customFields.actual_label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 p-0 m-0 text-right" v-if="team.has_reorder_and_hide_access">
                                            <i :class="'fa fa-eye mr-2 cursor-pointer eye-show-'+customFields.id" aria-hidden="true" v-if="customFields.label_view" @click="updateRecordDetailCustomFieldView(customFields, index, '0')"></i>
                                            <i :class="'fa fa-eye-slash mr-2 cursor-pointer eye-slash-'+customFields.id" style="color: #cc1f1a;" aria-hidden="true" v-if="!customFields.label_view" @click="updateRecordDetailCustomFieldView(customFields, index, '1')"></i>
                                            <button @click.prevent="openRecordDetailEditFieldModal(index, customFields, 'custom-data-label')"
                                                    class="btn btn-default btn-sm material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">edit
                                            </button>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                        </table>
                        <div v-if="recordDetailCustomFieldsLabelsLoader" class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only text-teal">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="editFieldModal" class="modal" role="dialog">
            <div class="modal-dialog">

                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Edit Field Label</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="current_label"
                                        :class="{'text-red': error_message}">Label</label>
                                <input v-model="form.current_label" id="current_label" name="current_label"
                                        class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                        :class="{'border-red': error_message}"
                                        placeholder="Enter Label" @keypress="clearErrors()">
                                <div class="text-red text-xs" v-if="error_message">
                                    Label field is required!
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-on="!isRecordDetailLabelEdit ? { click: () => saved() } : { click: () => saveRecordDetailLabel() }"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>


<script>
import Form from "../../../../utils/form";
import draggable from 'vuedraggable';
import axios from "axios";
export default {

    name: 'project-data-field-labels',
    components: {draggable},
    props: ['team'],
    data() {
        return {
            labels: [],
            customFieldsLables: [],
            tempLabels: [],
            tempCustomFields: [],
            tempMergedArray: [],
            form: new Form({
                index: '',
                id: '',
                type: '',
                actual_label: '',
                current_label: '',
                actual_label_slug: '',
                label_view:'',
                label_order:'',
                label_type:''
            }),
            error_message: false,
            labelsReorder:[],
            customLabelsReorder:[],
            baseUrl:window.location.origin,
            newProjectRequiredFields:null,
            pipelineRequiredFields:null,
            contractRequiredFields:null,
            deadRequiredFields:null,
            currentLabelUpdateValue:false,
            currentCustomFieldUpdateValue:false,
            labelsLoader: false,
            customFieldsLabelsLoader: false,
            recordDetailLabels: [],
            recordDetailLabelsLoader: false,
            recordDetailLabelsReorder:[],
            isRecordDetailLabelEdit: false,
            recordDetailCustomFieldsLabels: [],
            recordDetailCustomFieldsLabelsLoader: false,
            recordDetailCustomLabelsReorder:[],
        };
    },

    mounted() {
        this.fetchFieldsLabels();
        this.fetchRecordDetailFieldsLabels();
        this.fetchProjectCustomFields();
        this.fetchRecordDetailCustomFields();
        this.fetchRequiredFields();
    },

    methods: {
        fetchFieldsLabels(showLoader = true) {
            let self = this;
            if(showLoader) {
                this.labelsLoader = true;
            }
            this.label = [];
            this.tempLabels = [];
            this.tempCustomFields = [];
            this.tempMergedArray = [];
            this.labelsReorder = [];
            this.customLabelsReorder = [];

            axios.get(route('api.settings.project-data-fields-labels')).then((data) => {
                self.labelsLoader = false;
                let response = data.data.fieldLabels;
                if(response) {
                    this.labels = JSON.parse(response.labels).sort((a,b) => a.label_order - b.label_order);
                }
            }).catch((error) => {
                self.labelsLoader = false;
            });
        },
        fetchRecordDetailFieldsLabels(showLoader = true) {
            let self = this;
            if(showLoader) {
                this.recordDetailLabelsLoader = true;
            }
            this.recordDetailLabelsReorder = [];

            axios.get(route('api.settings.record-detail-field-labels')).then((data) => {
                self.recordDetailLabelsLoader = false;
                let response = data.data.fieldLabels;
                if(response) {
                    this.recordDetailLabels = JSON.parse(response.labels).sort((a,b) => a.label_order - b.label_order);
                }
            }).catch((error) => {
                self.recordDetailLabelsLoader = false;
            });
        },
        fetchProjectCustomFields(showLoader = true) {
            let self = this;
            if(showLoader) {
                this.customFieldsLabelsLoader = true;
            }
            this.tempLabels = [];
            this.tempCustomFields = [];
            this.tempMergedArray = [];
            this.labelsReorder = [];
            this.customLabelsReorder = [];
            axios.get(route('api.project-custom-field.index')).then((data) => {
                self.customFieldsLabelsLoader = false;
                this.customFieldsLables = data.data.data.sort((a,b) => a.label_order - b.label_order);
            }).catch((error) => {
                self.customFieldsLabelsLoader = false;
            });
        },
        fetchRecordDetailCustomFields(showLoader = true) {
            let self = this;
            if(showLoader) {
                this.recordDetailCustomFieldsLabelsLoader = true;
            }
            this.recordDetailCustomLabelsReorder = [];

            axios.get(route('api.record-detail-custom-field.index')).then((data) => {
                self.recordDetailCustomFieldsLabelsLoader = false;
                this.recordDetailCustomFieldsLabels = data.data.data.sort((a,b) => a.label_order - b.label_order);
            }).catch((error) => {
                self.recordDetailCustomFieldsLabelsLoader = false;
            });
        },
        openEditFieldModal(index, label, type) {
            this.error_message = false;
            if(type === 'project-data-label') {
                $("#editFieldModal").modal("show");
                this.form.index = index;
                this.form.id = label.id;
                this.form.type = label.type;
                this.form.actual_label = label.actual_label;
                this.form.current_label = label.current_label;
                this.form.actual_label_slug = label.actual_label_slug;
                this.form.label_view = label.label_view;
                this.form.label_order = label.label_order;
                this.form.label_type = label.label_type;
            }
            else {
                localStorage.setItem("currentCustomFieldId", label.id);
                window.location = route('settings.codes.project.custom-fields.index', {team: this.team.id});
            }
        },
        openRecordDetailEditFieldModal(index, label, type) {
            this.isRecordDetailLabelEdit = true;
            this.error_message = false;
            if(type === 'record-detail-label') {
                $("#editFieldModal").modal("show");
                this.form.index = index;
                this.form.id = label.id;
                this.form.type = label.type;
                this.form.actual_label = label.actual_label;
                this.form.current_label = label.current_label;
                this.form.actual_label_slug = label.actual_label_slug;
                this.form.label_view = label.label_view;
                this.form.label_order = label.label_order;
                this.form.label_type = label.label_type;
            }
            else {
                localStorage.setItem("currentRecordDetailCustomFieldId", label.id);
                window.location = route('settings.codes.project.record-details-custom-fields.index', {team: this.team.id});
            }
        },
        saved() {
            let self = this;
            let index = self.form.index;

            if(self.form.current_label === '') {
                self.error_message = true;
                return false;
            }

            let object = {
                "id": self.form.id,
                "type": self.form.type,
                "actual_label": self.form.actual_label,
                "current_label": self.form.current_label,
                "actual_label_slug": self.form.actual_label_slug,
                "label_view": self.form.label_view,
                "label_order": self.form.label_order,
                "label_type": self.form.label_type
            }

            Vue.set(self.labels, index, object);
            self.labels.sort((a,b) => (a.id - b.id));
            axios.post(route('api.settings.update-project-data-fields-labels'), { labelsArray: self.labels })
            .then(response => {
                $("#editFieldModal").modal("hide");
                self.fetchFieldsLabels(false);
            });
        },
        saveRecordDetailLabel() {
            let self = this;
            this.isRecordDetailLabelEdit = false;
            let index = self.form.index;

            if(self.form.current_label === '') {
                self.error_message = true;
                return false;
            }

            let object = {
                "id": self.form.id,
                "type": self.form.type,
                "actual_label": self.form.actual_label,
                "current_label": self.form.current_label,
                "actual_label_slug": self.form.actual_label_slug,
                "label_view": self.form.label_view,
                "label_order": self.form.label_order,
                "label_type": self.form.label_type
            }

            Vue.set(self.recordDetailLabels, index, object);
            self.recordDetailLabels.sort((a,b) => (a.id - b.id));
            axios.post(route('api.settings.update-record-detail-field-labels'), {labelsArray: self.recordDetailLabels}).then(response => {
                $("#editFieldModal").modal("hide");
                self.fetchRecordDetailFieldsLabels(false);
            });
        },
        clearErrors() {
            this.error_message = false;
        },
        updateView(label, index, viewOption){
            let self = this;
            if(this.newProjectRequiredFields){
                var underScoreKey = label.actual_label_slug.replace("-", "_");
                underScoreKey =  (underScoreKey == 'lead_source')? 'lead_from':underScoreKey;
                Object.keys(this.newProjectRequiredFields).some( function(key){
                    if (key.match(underScoreKey) != null) {
                       if(self.newProjectRequiredFields[key] == "true"){
                           self.currentLabelUpdateValue = true;
                       }
                    }
                });
            }

            if(this.pipelineRequiredFields){
                var underScoreKey = label.actual_label_slug.replace("-", "_");
                underScoreKey =  (underScoreKey == 'lead_source')? 'lead_from':underScoreKey;
                Object.keys(this.pipelineRequiredFields).some( function(key){
                    if (key.match(underScoreKey) != null) {
                        if(self.pipelineRequiredFields[key] == "true"){
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(this.contractRequiredFields){
                var underScoreKey = label.actual_label_slug.replace("-", "_");
                underScoreKey =  (underScoreKey == 'lead_source')? 'lead_from':underScoreKey;
                Object.keys(this.contractRequiredFields).some( function(key){
                    if (key.match(underScoreKey) != null) {
                        if(self.contractRequiredFields[key] == "true"){
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(this.deadRequiredFields){
                var underScoreKey = label.actual_label_slug.replace("-", "_");
                underScoreKey =  (underScoreKey == 'lead_source')? 'lead_from':underScoreKey;
                Object.keys(this.deadRequiredFields).some( function(key){
                    if (key.match(underScoreKey) != null) {
                        if(self.deadRequiredFields[key] == "true"){
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(self.currentLabelUpdateValue){
                self.getToast().fire({
                    type: 'error',
                    title: label.current_label + " is a Required Field and cannot be Hidden"
                });
                self.currentLabelUpdateValue = false;
                return false;
            }
            let object = {
                "id": label.id,
                "type": label.type,
                "actual_label": label.actual_label,
                "current_label": label.current_label,
                "actual_label_slug": label.actual_label_slug,
                "label_view": (viewOption == '1')? true:false,
                "label_order": label.label_order,
                "label_type": 'project_data_fields'
            }
            let tempLabelsForUpdateView = [];
            self.labels.forEach((item, indexNew) => {
                if(item.label_type == 'project_data_fields'){
                    let temObj = {
                        "id": item.id,
                        "type": item.type,
                        "actual_label": item.actual_label,
                        "current_label": item.current_label,
                        "actual_label_slug": item.actual_label_slug,
                        "label_view": item.label_view,
                        "label_order": item.label_order,
                        "label_type": 'project_data_fields'
                    }
                    tempLabelsForUpdateView.push(temObj);
                }
            });
            let indexFind = tempLabelsForUpdateView.findIndex(x => x.actual_label == label.actual_label)
            Vue.set(tempLabelsForUpdateView, indexFind, object);
            tempLabelsForUpdateView.sort((a,b) => (a.id - b.id));
            axios.post(route('api.settings.update-project-data-fields-labels'), {labelsArray: tempLabelsForUpdateView}).then(response => {
                self.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                self.fetchFieldsLabels(false);
            });
        },
        updateRecordDetailView(label, index, viewOption) {
            let self = this;

            if(this.newProjectRequiredFields) {
                let underScoreKey = label.actual_label_slug.replace("-", "_");
                Object.keys(this.newProjectRequiredFields).some(function(key) {
                    if(key.match(underScoreKey) != null) {
                        if(self.newProjectRequiredFields[key] == "true") {
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(this.pipelineRequiredFields) {
                let underScoreKey = label.actual_label_slug.replace("-", "_");
                Object.keys(this.pipelineRequiredFields).some(function(key) {
                    if (key.match(underScoreKey) != null) {
                        if(self.pipelineRequiredFields[key] == "true") {
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(this.contractRequiredFields) {
                let underScoreKey = label.actual_label_slug.replace("-", "_");
                Object.keys(this.contractRequiredFields).some(function(key) {
                    if(key.match(underScoreKey) != null) {
                        if(self.contractRequiredFields[key] == "true") {
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(this.deadRequiredFields) {
                let underScoreKey = label.actual_label_slug.replace("-", "_");
                Object.keys(this.deadRequiredFields).some(function(key) {
                    if(key.match(underScoreKey) != null) {
                        if(self.deadRequiredFields[key] == "true") {
                            self.currentLabelUpdateValue = true;
                        }
                    }
                });
            }

            if(self.currentLabelUpdateValue) {
                self.getToast().fire({
                    type: 'error',
                    title: label.current_label + " is a Required Field and cannot be Hidden"
                });
                self.currentLabelUpdateValue = false;
                return false;
            }

            let object = {
                "id": label.id,
                "type": label.type,
                "actual_label": label.actual_label,
                "current_label": label.current_label,
                "actual_label_slug": label.actual_label_slug,
                "label_view": viewOption == '1',
                "label_order": label.label_order,
                "label_type": 'record_detail_fields'
            };

            let tempLabelsForUpdateView = [];
            self.recordDetailLabels.forEach((item, indexNew) => {
                if(item.label_type === 'record_detail_fields') {
                    let temObj = {
                        "id": item.id,
                        "type": item.type,
                        "actual_label": item.actual_label,
                        "current_label": item.current_label,
                        "actual_label_slug": item.actual_label_slug,
                        "label_view": item.label_view,
                        "label_order": item.label_order,
                        "label_type": 'record_detail_fields'
                    }
                    tempLabelsForUpdateView.push(temObj);
                }
            });

            let indexFind = tempLabelsForUpdateView.findIndex(x => x.actual_label === label.actual_label)
            Vue.set(tempLabelsForUpdateView, indexFind, object);
            tempLabelsForUpdateView.sort((a,b) => (a.id - b.id));

            axios.post(route('api.settings.update-record-detail-field-labels'), {labelsArray: tempLabelsForUpdateView}).then(response => {
                self.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                self.fetchRecordDetailFieldsLabels(false);
            });
        },
        updateCustomFieldView(label, index, viewOption) {
            let self = this;

            if(this.newProjectRequiredFields){
                if(this.newProjectRequiredFields.custom_fields.length > 0){
                    this.newProjectRequiredFields.custom_fields.forEach(item => {
                        if(parseInt(item.id) == label.id){
                            if(item.value  == "true"){
                                self.currentCustomFieldUpdateValue = true;
                            }
                        }
                    });
                }
            }

            if(this.pipelineRequiredFields){
                if(this.pipelineRequiredFields.custom_fields.length > 0){
                    this.pipelineRequiredFields.custom_fields.forEach(item => {
                        if(parseInt(item.id) == label.id){
                            if(item.value == "true"){
                                self.currentCustomFieldUpdateValue = true;
                            }
                        }
                    });
                }
            }

            if(this.contractRequiredFields){
                if(this.contractRequiredFields.custom_fields.length > 0){
                    this.contractRequiredFields.custom_fields.forEach(item => {
                        if(parseInt(item.id) == label.id){
                            if(item.value == "true"){
                                self.currentCustomFieldUpdateValue = true;
                            }
                        }
                    });
                }
            }

            if(this.deadRequiredFields){
                if(this.deadRequiredFields.custom_fields.length > 0){
                    this.deadRequiredFields.custom_fields.forEach(item => {
                        if(parseInt(item.id) == label.id){
                            if(item.value == "true"){
                                self.currentCustomFieldUpdateValue = true;
                            }
                        }
                    });
                }
            }

            if(self.currentCustomFieldUpdateValue){
                self.getToast().fire({
                    type: 'error',
                    title: "Field is required in company setting required field"
                });
                self.currentCustomFieldUpdateValue = false;
                return false;
            }

            let object = {
                "id": label.id,
                "label_view": (viewOption == '1')? true:false,
            }
            axios.post(route('api.project-custom-field.viewOption'), { customFieldView: object })
                .then(response => {
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.fetchProjectCustomFields(false);
                });
        },
        updateRecordDetailCustomFieldView(label, index, viewOption) {
            let self = this;

            let object = {
                "id": label.id,
                "label_view": viewOption == '1',
            }
            axios.post(route('api.record-detail-custom-field.viewOption'), {customFieldView: object}).then(response => {
                self.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                self.fetchRecordDetailCustomFields(false);
            });
        },
        handleLabelOrderChange(event) {
            let self = this;
            if (event.moved) {
                self.$nextTick(() => {
                    self.labels.forEach((item, index) => {
                            let object = {
                                "id": item.id,
                                "type": item.type,
                                "actual_label": item.actual_label,
                                "current_label": item.current_label,
                                "actual_label_slug": item.actual_label_slug,
                                "label_view": item.label_view,
                                "label_order": index+1,
                                "label_type": 'project_data_fields'
                            }
                            Vue.set(self.labelsReorder, index, object);
                    });
                    let tempLabelReorder = self.labelsReorder.filter(x => x !== null);
                    tempLabelReorder.sort((a,b) => (a.id - b.id));
                    axios.post(route('api.settings.update-project-data-fields-labels'), { labelsArray: tempLabelReorder })
                        .then(response => {
                            self.labelsReorder = [];
                            self.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                        });

                    self.fetchFieldsLabels(false);
                });
            }
        },
        handleRecordDetailLabelOrderChange(event) {
            let self = this;
            if (event.moved) {
                self.$nextTick(() => {
                    self.recordDetailLabels.forEach((item, index) => {
                        let object = {
                            "id": item.id,
                            "type": item.type,
                            "actual_label": item.actual_label,
                            "current_label": item.current_label,
                            "actual_label_slug": item.actual_label_slug,
                            "label_view": item.label_view,
                            "label_order": index+1,
                            "label_type": 'record_detail_fields'
                        }
                        Vue.set(self.recordDetailLabelsReorder, index, object);
                    });
                    let tempLabelReorder = self.recordDetailLabelsReorder.filter(x => x !== null);
                    tempLabelReorder.sort((a,b) => (a.id - b.id));
                    axios.post(route('api.settings.update-record-detail-field-labels'), {labelsArray: tempLabelReorder}).then(response => {
                        self.recordDetailLabelsReorder = [];
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    });

                    self.fetchRecordDetailFieldsLabels(false);
                });
            }
        },
        handleCustomFieldsOrderChange(event) {
            let self = this;
            if (event.moved) {
                self.$nextTick(() => {
                    self.customFieldsLables.forEach((item, index) => {
                            let object = {
                                "id": item.id,
                                "label_order": index+1,
                            }
                            Vue.set(self.customLabelsReorder, index, object);
                    });
                    let tempCustomLabelsReorder = self.customLabelsReorder.filter(x => x !== null);

                    axios.post(route('api.project-custom-field.reorder'), { customFieldsArray: tempCustomLabelsReorder })
                        .then(response => {
                            self.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            self.customLabelsReorder = [];
                        });

                    self.fetchProjectCustomFields(false);
                });
            }
        },
        handleRecordDetailCustomFieldsOrderChange(event) {
            let self = this;
            if (event.moved) {
                self.$nextTick(() => {
                    self.recordDetailCustomFieldsLabels.forEach((item, index) => {
                        let object = {
                            "id": item.id,
                            "label_order": index+1,
                        }
                        Vue.set(self.recordDetailCustomLabelsReorder, index, object);
                    });
                    let tempCustomLabelsReorder = self.recordDetailCustomLabelsReorder.filter(x => x !== null);

                    axios.post(route('api.settings.reorder-record-detail-field-labels'), {customFieldsArray: tempCustomLabelsReorder}).then(response => {
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        self.recordDetailCustomLabelsReorder = [];
                    });

                    self.fetchRecordDetailCustomFields(false);
                });
            }
        },
        fetchRequiredFields() {
            axios.get(route('project.get-required-fields')).then((response) => {
                this.newProjectRequiredFields = response.data.new_file;
                this.pipelineRequiredFields = response.data.pipeline;
                this.contractRequiredFields = response.data.contract;
                this.deadRequiredFields = response.data.dead;
            });
        }
    },

}
</script>
<style lang="scss" escoped>
.project-data-label-hover:hover{
    background-color: #f5f5f5;
}
.drag-icon-img{
    width: 15px;
}
.drag-stop{
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}
</style>
